import useSWR from 'swr';
import { IDENTITY_CACHE_KEY_FN } from './internal/swrCache';
import useDialectSdk from './useDialectSdk';
const useIdentity = ({ address }) => {
    const sdk = useDialectSdk();
    const { data: identity, error: errorFetchingIdentity } = useSWR(IDENTITY_CACHE_KEY_FN(address), () => (address ? sdk.identity.resolve(address) : null));
    const loading = !errorFetchingIdentity && identity === undefined;
    return {
        identity: identity || null,
        loading,
    };
};
export default useIdentity;
//# sourceMappingURL=useIdentity.js.map